<template>
  <div class="mask" @click="closePreview" @mousewheel.prevent="rollImg">
    <div class="option">
      <a><a-icon type="plus-circle" @click="zoomAdd(10)" /></a>
      <a><a-icon type="minus-circle" @click="zoomAdd(-10)" /></a>
      <a><div class="one" @click="zoomBack">1:1</div></a>
      <a><a-icon type="undo" @click="rotatePic(-90)" /></a>
      <a><a-icon type="redo" @click="rotatePic(90)" /></a>
      <a :href="rootUrl + img" :download="rootUrl + img" target="_blank" v-if="showDownload">
        <a-icon type="download" />
      </a>
    </div>
    <div class="zoom" v-show="zoomShow">{{ currentZoom }}%</div>
    <div class="pic" ref="imgDiv" @mousedown="startMove">
      <a><img :src="img" ref="image" @load="centerImg" /></a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zoomShow: false,
      isDragging: false,
      timer: null,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0,
      rotateDeg: 0,
      rotateBackCount: 0,
      currentZoom: 100,
      rootUrl: "",
    };
  },
  props: {
    img: {
      type: String,
      default: "",
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    closeAble: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getHostUrl();
  },
  methods: {
    getHostUrl() {
      this.rootUrl = globalConfig.rootUrl + "/api/pcWeb/aliyun/getFile?url=";
    },
    closePreview(e) {
      // 点击图片不关闭
      if (e.target.classList.contains("mask") || this.closeAble) {
        this.$emit("closePreview");
      }
    },
    handleZoom() {
      this.$refs.imgDiv.style.transform = `
        scale(${this.currentZoom / 100})
        rotate(${this.rotateDeg}deg)
      `;
      this.zoomShow = true;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.zoomShow = false;
      }, 1000);
    },
    zoomAdd(num) {
      if (this.currentZoom + num >= 70 && this.currentZoom + num <= 300) {
        this.currentZoom += num;
        this.handleZoom();
      }
    },
    zoomBack() {
      let count = this.rotateBackCount % 4;
      let tempDeg =
        count == 0
          ? 0
          : count == -1
          ? 90
          : count == -3
          ? -90
          : count == 1
          ? -90
          : count == 3
          ? 90
          : -90 * count;
      this.rotateDeg += tempDeg;
      this.rotateBackCount = 0;
      this.currentZoom = 100;
      this.centerImg();
      this.handleZoom();
    },
    centerImg() {
      const imgDiv = this.$refs.imgDiv;
      const imgElement = this.$refs.image;
      // 确保图片和容器存在
      if (!imgDiv || !imgElement) return;
      // 获取图片和容器的尺寸
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;
      const imgWidth = imgElement.width;
      const imgHeight = imgElement.height;
      // 计算居中位置
      const centerX = (containerWidth - imgWidth) / 2;
      const centerY = (containerHeight - imgHeight) / 2;
      // 应用位置
      imgDiv.style.left = `${centerX}px`;
      imgDiv.style.top = `${centerY}px`;
    },
    rollImg(event) {
      event.preventDefault();
      const delta = Math.sign(event.deltaY);
      const zoomStep = 10; // 缩放比例
      this.currentZoom -= delta * zoomStep;
      this.currentZoom = Math.max(70, Math.min(300, this.currentZoom));
      this.handleZoom();
    },
    startMove(e) {
      if (e.button !== 0) return;
      e.preventDefault();
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.imgDiv.offsetLeft;
      this.startY = e.pageY - this.$refs.imgDiv.offsetTop;
      document.addEventListener("mousemove", this.moveImg);
      document.addEventListener("mouseup", this.stopMove);
    },

    moveImg(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.startX;
      const y = e.pageY - this.startY;
      this.$refs.imgDiv.style.left = x + "px";
      this.$refs.imgDiv.style.top = y + "px";
    },

    stopMove() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.moveImg);
      document.removeEventListener("mouseup", this.stopMove);
    },
    rotatePic(num) {
      this.rotateBackCount += num < 0 ? -1 : 1;
      this.rotateDeg += num;
      this.applyRotation();
    },

    // 应用旋转样式
    applyRotation() {
      this.$refs.imgDiv.style.transform = `
      scale(${this.currentZoom / 100})
      rotate(${this.rotateDeg}deg)
    `;
    },
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  color: aliceblue;
  user-select: none;
}
.option {
  position: absolute;
  width: 200px;
  height: 30px;
  bottom: 15px;
  left: calc(50% - 100px);
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0 12px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  z-index: 9998;
  justify-content: space-between;
  font-size: 22px;
  a {
    i {
      color: aliceblue;
    }
  }
  .one {
    text-align: center;
    width: 22px;
    height: 22px;
    line-height: 18px;
    border-radius: 50%;
    font-size: 12px;
    border: 2px solid aliceblue;
    color: aliceblue;
  }
}
.zoom {
  position: absolute;
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.5);
  line-height: 12px;
  color: 12px;
  border-radius: 24px;
  z-index: 9998;
}
.pic {
  position: absolute;
  cursor: grab;
  transform-origin: center center;
  transition: transform 0.3s ease;
  z-index: 9997;
  max-width: 100vw;
  max-height: 100vh;

  img {
    width: auto;
    height: auto;
    max-width: 100vw;
    max-height: 100vh;
    display: block;
    pointer-events: none;
  }
}
</style>